/*
 * collection-promo.js
 * Observer de vigencia para promociones de colección (PLP/PDP).
 *
 * Liquid no conoce la hora del servidor (por el caché), así que la decisión de
 * "¿la promo está vigente ahora?" se toma aquí, en el cliente, comparando
 * data-start / data-end (epoch en segundos) contra la hora local.
 *
 * Cuando una .promo-price está vigente:
 *   - se muestra (quita [hidden])
 *   - su contenedor de precio recibe la clase .has-promo (el CSS oculta el
 *     precio normal .promo-default)
 * Si no está vigente, no se toca nada -> queda el precio normal.
 *
 * Se re-evalúa al cargar, al volver a la pestaña, y ante cambios de DOM
 * (filtros AJAX de colección, quick view, cambio de variante, etc.).
 */
(function () {
  'use strict';

  var PRICE_CONTAINER = '.price, .price-box';

  function nowSeconds() {
    return Math.floor(Date.now() / 1000);
  }

  function isActive(el) {
    var now = nowSeconds();
    var start = parseInt(el.getAttribute('data-start'), 10);
    var end = parseInt(el.getAttribute('data-end'), 10);
    var afterStart = !start || isNaN(start) || now >= start;
    var beforeEnd = !end || isNaN(end) || now < end;
    return afterStart && beforeEnd;
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var promos = scope.querySelectorAll('.promo-price[data-promo]');
    promos.forEach(function (el) {
      var container = el.closest(PRICE_CONTAINER);
      if (isActive(el)) {
        el.hidden = false;
        if (container) container.classList.add('has-promo');
      } else {
        el.hidden = true;
        if (container) container.classList.remove('has-promo');
      }
    });
  }

  function init() {
    apply(document);

    // Re-evaluar al volver a la pestaña (por si expiró mientras estaba abierta).
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) apply(document);
    });

    // Re-aplicar cuando el tema inyecta cards/precios por AJAX (filtros, quickview...).
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            apply(document);
            return;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exponer por si otro script (cambio de variante) necesita re-evaluar manualmente.
  window.refreshCollectionPromos = function () { apply(document); };
})();
